export default {
    revokeSetData: { method: 'post', url: 'api/guests/access_locations/data' },
    revokeGetData: { method: 'get', url: 'api/guests/access_locations/data' }
}